import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatLocation(location: string | null): string {
  if (!location) return '';
  
  // Handle special cases first
  const specialCases: Record<string, string> = {
    'united-kingdom': 'United Kingdom',
    'united kingdom': 'United Kingdom',
    'uk': 'United Kingdom',
    'united-states': 'United States',
    'united states': 'United States',
    'usa': 'United States',
    'us': 'United States',
    'south-africa': 'South Africa',
    'south africa': 'South Africa',
    'ivory-coast': 'Ivory Coast',
    'ivory coast': 'Ivory Coast',
    'cote-d-ivoire': 'Côte d\'Ivoire',
    'cote d\'ivoire': 'Côte d\'Ivoire',
    'cape-verde': 'Cape Verde',
    'cape verde': 'Cape Verde'
  };
  
  const lowerLocation = location.toLowerCase().trim();
  
  // Check for special cases first
  if (specialCases[lowerLocation]) {
    return specialCases[lowerLocation];
  }
  
  // Default title case formatting
  return location
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}